import AppConstants from '../config/app.constants';

let ScanService = function ($http, $q) {

    let scanRoute = (branchId, id, date, isCheckin, isCheckout, requireRouteDetail) => {
        return $http
            .post(AppConstants.api + `/scan/route`, {
                id,
                branchId,
                date,
                isCheckin,
                isCheckout,
                requireRouteDetail
            })
            .then((res) => {
                return res.data
            })
    };

    let scanMessenger = (branchId, routeId, messengerId, vaultDate, requireRtDetail) => {
        return $http
            .post(AppConstants.api + `/scan/messenger`, {
                branchId,
                routeId,
                messengerId,
                vaultDate,
                requireRtDetail
            })
            .then((res) => {
                return res.data
            })
    };

    let scanFromTanker = (routeId, routeDate) => {
        return $http
            .post(AppConstants.api + `/scan/fromTanker`, {
                routeId,
                routeDate
            })
            .then((res) => {
                return res.data
            })
    };

    let scanTruckId = (truckId) => {
        return $http.post(AppConstants.api + `/scan/truckId`, {
            truckId
        }).then((res) => {
            return res.data;
        })
    }

    let scanSupervisor = (id, password, event, branch, details) => {
        return $http
            .post(AppConstants.api + `/scan/supervisor`, {
                id,
                password,
                event,
                branch,
                details
            })
            .then((res) => {
                return res.data
            })
    };

    let routeCheckinVerify = (branchId, id, date, userId) => {
        return $http
            .post(AppConstants.api + `/scan/route-checkin-verify`, {
                branchId,
                id,
                date,
                userId
            })
            .then((res) => {
                return res.data
            })
    };

    let routeCheckoutVerify = (branchId, id, date, userId) => {
        return $http
            .post(AppConstants.api + `/scan/route-checkout-verify`, {
                branchId,
                id,
                date,
                userId
            })
            .then((res) => {
                return res.data
            })
    };

    let verifyRouteThrowShipment = (branchId, trackingId, deliveryDate) => {
        return $http
            .post(AppConstants.api + `/scan/route-throw-shipment-verify`, {
                branchId,
                trackingId,
                deliveryDate
            })
            .then((res) => {
                return res.data
            })
    }

    let shipmentCheckInCheckOutData = (branchId, routeId, vaultDate) => {
        return $http
            .get(AppConstants.api + `/scan/checkin-checkout-data`, {
                params: {
                    branchId, routeId, vaultDate
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let validateTotanker = (tankerId) => {
        return $http
            .get(AppConstants.api + `/scan/validate-to-tanker`, {
                params: {
                    tankerId
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let getShipmentTanker = (branch, vaultDate) => {
        return $http
            .get(AppConstants.api + `/scan/shipment-tanker`, {
                params: {
                    branch,
                    vaultDate
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let shipmentVerify = (route, date, isCoinCheckOut, branch) => {
        return $http
            .post(AppConstants.api + `/scan/shipment-verify`, {
                route,
                date,
                isCoinCheckOut,
                branch
            })
            .then((res) => {
                return res.data
            })
    };

    let updateTrackingId = (oldTrackingId, newTrackingId, comment, supervisorId, branchId) => {
        return $http
            .post(AppConstants.api + `/scan/update-tracking-id`, {
                oldTrackingId,
                newTrackingId,
                comment,
                supervisorId,
                branchId
            })
            .then((res) => {
                return res.data
            })
    }

    let shipmentThrowCount = (routeId, branchId, date, isCoinCheckOut) => {
        return $http
            .post(AppConstants.api + `/scan/throw-count`, {
                routeId,
                branchId,
                date,
                isCoinCheckOut
            })
            .then((res) => {
                return res.data
            })
    };

    let shipmentThrowList = (routeId, branchId, date, isCoinCheckOut) => {
        return $http
            .post(AppConstants.api + `/scan/throw-list`, {
                routeId,
                branchId,
                date,
                isCoinCheckOut
            })
            .then((res) => {
                return res.data
            })
    };

    let verifyCoin = (routeId, vaultDate) => {
        return $http
            .post(AppConstants.api + `/scan/verify-coin`, {
                routeId,
                vaultDate
            })
            .then((res) => {
                return res.data
            })
    }
    let getCurrentDenomLedgerBalance = (branchId, account, allCoins, routeId, vaultDate) => {
        return $http
            .post(AppConstants.api + `/scan/get-current-balance`, {
                branchId,
                account,
                allCoins,
                routeId, 
                vaultDate
            })
            .then((res) => {
                return res.data
            })
    }

    let verifyRouteCoin = (routeId, vaultDate, branchId, coinIds) => {
        return $http
            .post(AppConstants.api + `/scan/route-coin-verify`, {
                routeId,
                vaultDate,
                branchId,
                coinIds
            })
            .then((res) => {
                return res.data
            })
    }

    let updateRouteCheckoutStartTime = (routeId, routeDate) => {
        return $http
            .post(AppConstants.api + `/scan/update-route-checkout-start-time`, {
                routeId,
                routeDate
            })
            .then((res) => {
                return res.data
            })
    }

    let getCheckoutUserAssignedItems = (routeId, branchId, userId) => {
        return $http
            .post(AppConstants.api + `/scan/get-checkout-user-assigned-items`, {
                routeId,
                branchId,
                userId
            })
            .then((res) => {
                return res.data
            })
    }

    let getCheckinUserAssignedItems = (routeId, branchId, userId) => {
        return $http
            .post(AppConstants.api + `/scan/get-checkin-user-assigned-items`, {
                routeId,
                branchId,
                userId
            })
            .then((res) => {
                return res.data
            })
    }

    return {
        scanRoute,
        scanMessenger,
        scanFromTanker,
        scanSupervisor,
        routeCheckinVerify,
        routeCheckoutVerify,
        verifyRouteThrowShipment,
        shipmentCheckInCheckOutData,
        validateTotanker,
        getShipmentTanker,
        shipmentVerify,
        updateTrackingId,
        shipmentThrowCount,
        shipmentThrowList,
        verifyCoin,
        verifyRouteCoin,
        updateRouteCheckoutStartTime,
        getCurrentDenomLedgerBalance,
        scanTruckId,
        getCheckoutUserAssignedItems,
        getCheckinUserAssignedItems
    };
};

ScanService.$inject = ['$http', '$q']

export default ScanService;



// WEBPACK FOOTER //
// ./client/app/services/scan.service.js